import { useQuery } from "@tanstack/react-query";
import { useApi, fmtDate } from "@/lib/api";

export function MessagesTab() {
  const api = useApi();
  const { data = [] } = useQuery({ queryKey: ["admin-messages"], queryFn: () => api("get", "/admin/messages"), staleTime: 0 });
  if (!data.length) return <p className="bg-white border border-slate-200 rounded-sm p-10 text-center text-slate-500" data-testid="messages-empty">No contact messages yet.</p>;
  return (
    <div className="grid gap-4" data-testid="messages-list">
      {data.map((m) => (
        <div key={m.id} className="bg-white border border-slate-200 rounded-sm p-6 space-y-2">
          <div className="flex flex-wrap justify-between gap-2">
            <p className="font-display font-semibold">{m.name} · <a href={`mailto:${m.email}`} className="text-[#FF6B00] font-normal text-sm">{m.email}</a></p>
            <p className="text-xs font-mono text-slate-400">{fmtDate(m.created_at)}</p>
          </div>
          {m.subject && <p className="text-sm font-medium">{m.subject}</p>}
          <p className="text-sm text-slate-600 whitespace-pre-wrap">{m.message}</p>
        </div>
      ))}
    </div>
  );
}
